<div class="download-dialog">
  <h2 mat-dialog-title> {{ data.title}} </h2>
  
  <mat-dialog-content>
    <!-- Check icon conditionally displayed -->
    <!-- <div class="check-icon-container" *ngIf="data.documentType"> -->
    <div class="success-container">
      <mat-icon class="success-icon mb-3" color="primary">check_circle</mat-icon>
      <p class="success-message">Documento pronto per il download.</p>
    </div>

    <p>{{ data.documentType }} per <strong>{{ data.companyName }}</strong> {{ data.text }}</p>
    <p>Puoi ora scaricare il PDF oppure inviarlo direttamente per mail.</p>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <div class="actions-primary-row">
      <button
        mat-raised-button
        (click)="sendEmail()"
        class="email-button">
        <mat-icon>outgoing_mail</mat-icon>
        Invia email
      </button>

      <button
        mat-raised-button
        color="primary"
        (click)="downloadPdf()"
        class="download-button">
        <mat-icon>download</mat-icon>
        Scarica PDF
      </button>
    </div>

    <div class="actions-secondary-row">
      <button
        mat-button
        (click)="closeDialog()"
        class="mt-3 close-button">
        Chiudi
      </button>
    </div>
  </mat-dialog-actions>
</div>